export var version = '8.1.0'; // Note: This file is automatically generated when building math.js.
// Changes made in this file will be overwritten.


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/version.js
// module id = null
// module chunks = 